import {useIntl} from 'react-intl';
import {PaginationState} from '@tanstack/table-core/src/features/Pagination';

interface PaginationDetailProps {
    pagination: PaginationState;
    totalNumber: number;
    elementName?: string;
    elementNamePlural?: string;
}

const PaginationDetail = ({
    pagination,
    totalNumber,
    elementName,
    elementNamePlural,
}: PaginationDetailProps): JSX.Element => {
    const intl = useIntl();

    const currentPageState = pagination.pageIndex + 1;
    const pageSize = pagination.pageSize;
    const rightDisplay = currentPageState * pageSize;
    const leftDisplay = rightDisplay - pageSize + (currentPageState === 1 ? 1 : 0);

    const text = elementName ?? intl.formatMessage({id: 'TABLE.DEFAULT.ELEMENT_NAME'});
    const pluralText =
        elementNamePlural ?? intl.formatMessage({id: 'TABLE.DEFAULT.ELEMENT_NAME_PLURAL'});

    return (
        <div className="fs-6 fw-semibold text-gray-700">
            {leftDisplay}-{rightDisplay} {intl.formatMessage({id: 'TABLE.PAGINATION.OF'})} {totalNumber} {totalNumber > 1 ? pluralText : text}
        </div>
    );
};

export default PaginationDetail;
